import { soundex } from 'soundex-code'

// second one is for local from seeders data naming
export const ALLOWED_BAD_PAYERS_PROVIDERS = ['Total Energie_Callcenter', 'Total Direct Energie_Callcenter']

export const forceIsRealOrMensualityPayment = attributes => {
  const realPaymentEnabled = attributes?.payment_mode_real_status ?? null
  const mensualityPaymentEnabled = attributes?.payment_mode_mensuality_status ?? null

  if (mensualityPaymentEnabled !== 'active' && realPaymentEnabled === 'active') {
    return 1
  }

  if (mensualityPaymentEnabled === 'active' && realPaymentEnabled !== 'active') {
    return 0
  }

  return null
}

export const isPodMandatoryFromAttributes = attributes => {
  return attributes?.pdl_pce_mandatory !== 'inactive'
}

export const isPotentialBadPayer = (lastname, oldOccupant, meterState) => {
  if (meterState !== 'close' || oldOccupant === '' || lastname === '') {
    return false
  }

  const splittedOldOccupant = oldOccupant?.split(' ')

  if (!splittedOldOccupant || splittedOldOccupant.length === 0) {
    return false
  }

  return soundex(lastname) === soundex(splittedOldOccupant[0])
}

export const providerIsAllowedForBadPayer = (providerName, isBadPayer) => {
  if (!isBadPayer || !providerName) {
    return true
  }

  return ALLOWED_BAD_PAYERS_PROVIDERS.includes(providerName)
}

export const filterProvidersForBadPayer = (providers, isBadPayer) => {
  if (!isBadPayer || !providers) {
    return providers
  }

  return Object.values(providers ?? []).filter(provider => ALLOWED_BAD_PAYERS_PROVIDERS.includes(provider.name))
}

export const calculateOfferAvailability = (
  offersFromPdl,
  energyType,
  offerZohoId,
  currentOfferId,
  prestationType,
  cdfDelayed,
) => {
  let offerIsAvailableFromPdl = true
  let offerErrorMessage = ''
  let availableBillingType = ['real', 'mensuality']
  const isNotElecOrDual = energyType !== 'elec' && energyType !== 'dual'

  if (isNotElecOrDual || offersFromPdl.length === 0) {
    return { offerIsAvailable: offerIsAvailableFromPdl, offerErrorMessage, availableBillingType }
  }
  for (let i = 0; i < offersFromPdl.length; i++) {
    const offer = offersFromPdl[i]
    if (offer.product_zoho_id !== offerZohoId || offer.hop_id !== parseInt(currentOfferId)) {
      continue
    }
    const statusToCheck = prestationType === 'cdf' ? 'availabilityCdf' : 'availabilityMes'
    if (offer[statusToCheck] === false && cdfDelayed === 0) {
      offerIsAvailableFromPdl = false
      offerErrorMessage = offer.reason ?? ''
    }
    if (Object.prototype.hasOwnProperty.call(offer, 'billingType')) {
      availableBillingType = offer.billingType
    }
  }
  return { offerIsAvailable: offerIsAvailableFromPdl, offerErrorMessage, availableBillingType }
}

export const retrieveNeededParamsForOffers = data => {
  const { providerId, clientType, energyType, prestationType, isDebordement, zipcode } = data
  const params = []
  params.push('provider_id=' + providerId)
  params.push('contract_type=' + clientType)
  params.push('energy_type=' + energyType)
  params.push('prestation_type=' + prestationType)
  params.push('debordement_confirmation=' + (isDebordement ? 1 : 0))
  params.push('zipcode=' + zipcode)

  return params.join('&')
}
